module.exports = __webpack_public_path__ + "img/mdcai_logo_dark_v1.9e828616.svg";